import { render } from "./ApartmentManagementLayout.vue?vue&type=template&id=e0bf81d4"
import script from "./ApartmentManagementLayout.vue?vue&type=script&lang=js"
export * from "./ApartmentManagementLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__